import {UPDATE_ADD_MEDIA_VALUES, REQUEST_ADD_MEDIA, RECIEVE_ADD_MEDIA, CLEAR_ADD_MEDIA_VALUES} from '../constants/actionTypes';

const addSceneMediaDataInitialState = {
    path: '',
    repository: '',
    mediaName: '',
    dataset: '',
    language: '',

    pathValid: false,
    repositoryValid: false,
    mediaNameValid: false,
    datasetValid: false,
    languageValid: false,

    isAdding: false
};

export const addSceneMediaData = (state = addSceneMediaDataInitialState, action) => {
    switch(action.type) {
        case UPDATE_ADD_MEDIA_VALUES:
            return {
                ...state,
                ...action.values
            };

        case REQUEST_ADD_MEDIA:
            return {
                ...state,
                isAdding: true
            };
        
        case RECIEVE_ADD_MEDIA:
            return {
                ...state,
                isAdding: false
            };
        
        case CLEAR_ADD_MEDIA_VALUES:
            return addSceneMediaDataInitialState;
        
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/addSceneMediaData.js